<template>
    <div>
        <div style="width: 100%; height: 100%">
            <img src="../assets/img/home.jpg" alt="foot" width="100%" />
        </div>
        <div style="text-algin: center; margin: 30px 0">
            &copy; 海南亿万未来科技有限公司
            <a
                target="_blank"
                href="https://beian.miit.gov.cn/#/Integrated/index"
                >琼ICP备2023003919号</a
            >
        </div>
    </div>
</template>

<script>
export default {
    name: "home",
    data() {
        return {};
    },
};
</script>

<style scoped>
a {
    color: black;
    text-underline: none;
}
</style>
